module.exports = __webpack_public_path__ + "img/downloads.999d14c0.svg";